import React from 'react';
import { Box, Flex, HStack, Text, Circle, Icon, Heading } from '@chakra-ui/react';

const ProcessStep = ({ number, icon, title, description, isLast = false, ...rest }) => {
  return (
    <Flex direction="column" align="center" position="relative" zIndex={1} {...rest}>
      {/* Connector arrow to next step (desktop only) — single continuous line + CSS triangle */}
      {!isLast && (
        <Box
          position="absolute"
          top="14px"
          right={{ md: '-12%', lg: '-12%' }}
          width={{ md: '24%', lg: '24%' }}
          h="1px"
          bg="rgba(212,168,95,0.45)"
          display={{ base: 'none', md: 'block' }}
          zIndex={0}
          pointerEvents="none"
          _after={{
            content: '""',
            position: 'absolute',
            right: '-1px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 0,
            height: 0,
            borderTop: '4px solid transparent',
            borderBottom: '4px solid transparent',
            borderLeft: '6px solid rgba(212,168,95,0.85)',
          }}
        />
      )}

      {/* Top row: number circle beside icon */}
      <HStack spacing={3} mb={3} position="relative" zIndex={2}>
        <Circle
          size="30px"
          bg="linear-gradient(135deg, #D4A85F 0%, #E0B873 100%)"
          color="#071326"
          fontFamily="heading"
          fontWeight={500}
          fontSize="md"
          flexShrink={0}
          boxShadow="0 0 0 6px rgba(212,168,95,0.06)"
        >
          {number}
        </Circle>
        <Icon as={icon} boxSize={8} color="#D6DCE5" strokeWidth={1.4} />
      </HStack>

      {/* Title */}
      <Heading
        as="h3"
        fontFamily="heading"
        fontSize={{ base: '1rem', md: '1.1rem' }}
        fontWeight={500}
        color="#F5F7FA"
        mb={1.5}
        textAlign="center"
        letterSpacing="0"
      >
        {title}
      </Heading>

      {/* Description */}
      <Text
        fontFamily="body"
        fontSize="xs"
        color="#9AA7B8"
        textAlign="center"
        maxW="200px"
        lineHeight={1.6}
      >
        {description}
      </Text>
    </Flex>
  );
};

export default ProcessStep;
